import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import Button from "@mui/material/Button";
import { Modal } from "react-bootstrap";
import ReactiveButton from "reactive-button";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import blogFetch from "../../axios/config";
import RegisterOcurrence from "./RegisterOcurrence";
import { DateFromMinutes } from "../../utils/DataUtils";
import {
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
} from "@mui/material";
import moment from "moment";
import "moment/locale/pt-br";
import { IOccurrence } from "./occurrenceInterfaces";
import Context from "../../context/Context";
import language from "../../nls/language.json";

export default function Occurrence() {
  const [occurences, setOccurences] = useState<IOccurrence>();
  const [showModal, setShowModal] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [state, setState] = useState("idle");
  const [OccurrenceId, setOccurrenceId] = useState<number>(0);
  const { useRef } = React;
  const ref: any = useRef();

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getOccurence();
  }, []);

  const getOccurence = async () => {
    try {
      let response = await blogFetch.get("/Occurrence");
      let data = response.data;
      setOccurences(data);
    } catch (error) {
      console.error(error);
    }
  };

  const saveButton = async () => {
    setState("loading");
    var response = await ref.current.addOcurrence();
    if (response != null) {
      setState("success");
    } else {
      setState("error");
    }
    getOccurence();
  };

  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterOcurrence ref={ref}></RegisterOcurrence>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="contained"
            className="butto"
            onClick={() => setShowModalAdd(false)}
          >
            {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.modal.adicionar.btnCancelar}
          </Button>
          <ReactiveButton
            buttonState={state}
            idleText="Salvar"
            loadingText="Loading"
            successText="Ok"
            errorText="Erro"
            onClick={saveButton}
            className="butto"
          />
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterOcurrence
            ref={ref}
            IdOcurrence={OccurrenceId}
          ></RegisterOcurrence>
        </Modal.Body>{" "}
        <Modal.Footer>
          <Button variant="outlined" onClick={() => setShowModalEdit(false)}>
            {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.modal.editar.btnCancelar}
          </Button>
          <Button
            variant="contained"
            onClick={async () => {
              await ref.current.updateOcurrence();
              setShowModalEdit(false);
              getOccurence();
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.modal.editar.btnSalvar}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
             {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.title}
            </h3>
          </div>
          <div>
            <Button
              className="add_button"
              variant="contained"
              onClick={() => {
                modalAdd();
                setShowModal(true);
              }}
            >
              {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.btnAdicionar}
            </Button>
          </div>
        </div>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className="table-header">
              <TableCell>#</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.tableHeader.descricao}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.tableHeader.tipo}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.tableHeader.equipamento}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.tableHeader.tempo}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.tableHeader.dataHora}</TableCell>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.tableHeader.editar}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!!occurences &&
              Object.entries(occurences).map((item) => (
                <TableRow
                  key={item[1].ocC_PK_idOccurrence}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    padding: "0px",
                  }}
                >
                  <TableCell component="th" scope="row">
                    {item[1].ocC_PK_idOccurrence}
                  </TableCell>
                  <TableCell>{item[1].ocC_justify}</TableCell>
                  <TableCell>
                    {item[1].typeOccurrence.tpO_description}{" "}
                  </TableCell>
                  <TableCell>{item[1].skuEquipment.skE_description}</TableCell>
                  <TableCell>{DateFromMinutes(item[1].ocC_downtime)}</TableCell>
                  <TableCell>
                    {moment(item[1].ocC_DATE).format("LLL")}
                  </TableCell>
                  <TableCell>
                    {" "}
                    <ModeEditIcon
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        setOccurrenceId(item[1].ocC_PK_idOccurrence);
                        setShowModalEdit(true);
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
          {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterOcurrence ref={ref}></RegisterOcurrence>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={() => setShowModal(false)}>
           {(language as Record<string, any>)[selectedCountry.name].Ocorrencias.ocorrencias.modal.adicionar.btnCancelar}
          </Button>
          <ReactiveButton
            buttonState={state}
            idleText="Salvar"
            loadingText="Loading"
            successText="Ok"
            errorText="Erro"
            onClick={saveButton}
            className="butto"
          />
        </Modal.Footer>
      </Modal>
      {modalAdd()}
      {modalEdit()}
    </>
  );
}
